<script lang="ts" setup>
const props = defineProps({
  title: String,
  subtitle: String,
  videoSrc: String,
  inline: Boolean,
});
</script>

<template>
  <div :class="['empty-state', { 'inline': props.inline }]">
    <video autoplay muted class="message-animation">
      <!-- <source src="/media/videos/premium.webm" type="video/webm"> -->
      <source :src="videoSrc" type="video/webm">
    </video>
    <h2>{{ props.title }}</h2>
    <p>{{ props.subtitle }}</p>
    <slot />
  </div>
</template>

<style lang="postcss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  height: fill-container;
  color: var(--color-slate-500);
  margin: 8rem 0;
  max-width: 100%;
  text-align: center;
}

.empty-state.inline {
  margin: 1rem 0;
}

.message-animation {
  width: 150px;
  opacity: 0.8;
}

h2 {
  margin: 1rem 0;
}

p {
  max-width: 25rem;
  margin-bottom: 2rem;
}
</style>
